import React from 'react'
import { css } from '@emotion/core'
import { Card, Separator, Row, colors, Bleed, H2, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import SearchResult from './SearchResult'

const listItemCss = css`
  list-style: none;
`

const RankingPanel = ({ draggedItems, nativeDragApi, onResetOrder }) => {
  const [t] = useTranslation()

  return (
    <Card maxWidth={1300} backgroundColor={colors.gray00} edges="none">
      <Bleed all>
        <H2 id="draggable-list-heading" size="H5">
          {t('place-learn-to-rank-page.ranking-panel.drag-to-reorder.heading', 'Ranking - Drag to reorder.')}
        </H2>
        <Row alignX="start">
          <Button size="sm" onClick={onResetOrder}>
            {t('place-learn-to-rank-page.ranking-panel.reset-order.label', 'Reset to original order')}
          </Button>
        </Row>
        <Separator />
        <Row css={listItemCss} as="ol" guttersX="nano" aria-labelledby="draggable-list-heading" wrap>
          {draggedItems.map((result, index) => (
            <li key={result.id} css={listItemCss}>
              <SearchResult
                result={result}
                dragIndex={index}
                nativeDragApi={nativeDragApi}
                totalItems={draggedItems.length}
              />
            </li>
          ))}
        </Row>
      </Bleed>
    </Card>
  )
}

export default RankingPanel
